import {AnnualPolicyInfo, PaymentCard} from "@ferry/journey-services";
import * as React from "react";
import { Link } from "react-router-dom";
import { CardReuseCheckbox } from "../CardReuseCheckbox";
import { CreditCardSection } from "../CreditCardSection";
import {InfoBanner, resourcesHelper} from "@ferry/portal-core";

interface IProps {
    policyNumber: string;
    payment: string;
    handleReuseCardChange?: (reuseValue: boolean) => void;
    mainCardId?: string;
    annualPolicyInfo: AnnualPolicyInfo;
    hasRefundMandate?: boolean;
}

export class AnnualPaymentCardsSection extends React.Component<IProps> {
    constructor(props: any) {
        super(props);

        window.sessionStorage.setItem("product", "annualMotor");

        if (this.props.payment !== undefined) {
            window.sessionStorage.setItem("payment", this.props.payment);
        }
    }

    public render() {
        const mainPaymentCard: PaymentCard | undefined = this.getMainPaymentCard();

        return (
            <div className="payment-card-section">
                <div className="d-flex flex-row">
                    <div className="d-none d-md-flex flex-column">
                        <img
                            className="icon-panel mb-0"
                            src={`/${resourcesHelper.THEME_PATH}/img/payment-wallet.svg`}
                            alt="Credit card icon"
                            aria-label="Credit card icon"
                        />
                    </div>
                    <div className="d-flex flex-column justify-c-center">
                        <div className="d-md-none d-flex align-i-center mb-3">
                            <img
                                className="icon-panel mb-0"
                                src={`/${resourcesHelper.THEME_PATH}/img/payment-wallet.svg`}
                                alt="Credit card icon"
                                aria-label="Credit card icon"
                            />
                            <h2 className="font-family-display font-weight-bold mb-0">Card details</h2>
                        </div>
                        <div className="d-flex flex-column">
                            <h2 className="font-family-display font-weight-bold d-md-block d-none mb-4">Card details</h2>
                            {this.props.hasRefundMandate && (
                                <InfoBanner wording={<>Heads up - these are the details used to pay for your annual premium</>}/>
                            )}
                            <CreditCardSection mainCard={mainPaymentCard} />
                            {mainPaymentCard && (
                                <CardReuseCheckbox
                                    reuseCard={mainPaymentCard.reuseCard}
                                    mainPaymentCard={mainPaymentCard}
                                    policyNumber={this.props.policyNumber}
                                    handleReuseCardChange={this.props.handleReuseCardChange}
                                />
                            )}
                            <Link
                                to={{
                                    pathname: `/dashboard/account/changeCard/${this.props.policyNumber}`,
                                }}
                                state={{ policyNumber: this.props.policyNumber }}
                                id="changeCard">
                                <button className="change-card-button btn btn-blue-dashboard mt-0 mb-0">Change card</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private getMainPaymentCard(): PaymentCard | undefined {
        if (this.props.annualPolicyInfo && this.props.annualPolicyInfo.paymentCards) {
            const mainCards: PaymentCard[] = this.props.annualPolicyInfo.paymentCards.filter(c => c.id.toString() === this.props.mainCardId);

            return mainCards ? mainCards[0] : undefined;
        }

        return undefined;
    }
}
